var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReflect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "752pt",
    height: "752pt",
    viewBox: "0 0 752 752",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m582.96 221.61-104.19-66.773c-7.5781-4.7344-17.523-5.2109-25.574-0.94531-8.0508 4.2617-12.785 12.785-12.785 21.785v39.309l-140.18-0.003906c-74.352 0-134.5 60.617-134.5 134.5v31.258c0 15.156 12.312 27.469 27.469 27.469s27.469-12.312 27.469-27.469v-31.258c0-44.043 35.992-80.035 80.035-80.035h140.18v40.254c0 8.9961 4.7344 17.523 12.785 21.785 3.7891 1.8945 8.0508 2.8398 11.84 2.8398 4.7344 0 9.4727-1.4219 13.262-3.7891l104.19-66.773c7.1055-4.7344 11.367-12.312 11.367-20.836-0.003907-8.5234-4.2656-16.574-11.367-21.312z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.28 343.32c-15.156 0-27.469 12.312-27.469 27.469v31.258c0 44.043-35.992 80.035-80.035 80.035l-140.18-0.003907v-39.777c0-8.9961-4.7344-17.523-12.785-21.785-8.0508-4.2617-17.523-4.2617-25.574 0.94531l-104.19 66.773c-7.1055 4.7344-11.367 12.312-11.367 20.836 0 8.5234 4.2617 16.574 11.367 20.836l104.19 66.773c4.2617 2.8398 8.5234 3.7891 13.262 3.7891 4.2617 0 8.0508-0.94531 11.84-2.8398 8.0508-4.2617 12.785-12.785 12.785-21.785v-39.309l140.65 0.007813c74.352 0 134.5-60.617 134.5-134.5v-31.258c0-15.156-12.312-27.469-26.992-27.469z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReflect);
export default __webpack_public_path__ + "static/media/Reflect.f3541660d97ab0aa08c9a962884d004e.svg";
export { ForwardRef as ReactComponent };